import * as React from 'react'
import { colors } from './styleguide'

export default ({ icon, className, primary }) => {
  switch (icon) {
    case 'response-rates':
      return (
        <svg
          className={className}
          width="28px"
          height="37px"
          viewBox="0 0 37 37"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <g
            id="Desktop-Copy-3"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd">
            <g
              id="Desktop-Home-Copy-6"
              transform="translate(-99.000000, -644.000000)"
              fill={primary ? colors.primary : colors.secondary}
              fill-rule="nonzero">
              <g id="Group-11" transform="translate(99.000000, 625.000000)">
                <g
                  id="ic_chat_black_24px"
                  transform="translate(0.000000, 19.000000)">
                  <path
                    d="M33.3,0 L3.7,0 C1.665,0 0.0185,1.665 0.0185,3.7 L0,37 L7.4,29.6 L33.3,29.6 C35.335,29.6 37,27.935 37,25.9 L37,3.7 C37,1.665 35.335,0 33.3,0 Z M7.74418605,12.9069767 L30.1162791,12.9069767 L30.1162791,16.3488372 L7.74418605,16.3488372 L7.74418605,12.9069767 Z M22.372093,22.372093 L7.74418605,22.372093 L7.74418605,18.9302326 L22.372093,18.9302326 L22.372093,22.372093 Z M30.1162791,11.1860465 L7.74418605,11.1860465 L7.74418605,7.74418605 L30.1162791,7.74418605 L30.1162791,11.1860465 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    case 'heart':
      return (
        <svg
          width="33px"
          className={className}
          height="32px"
          viewBox="0 0 33 32"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <g
            id="Desktop-Copy-3"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd">
            <g
              id="Desktop-Home-Copy-6"
              transform="translate(-638.000000, -1002.000000)"
              fill={primary ? colors.primary : colors.secondary}
              fill-rule="nonzero">
              <g id="Group-14" transform="translate(638.000000, 984.000000)">
                <g id="Group-8">
                  <g
                    id="ic_favorite_black_24px-(1)"
                    transform="translate(0.000000, 18.000000)">
                    <path
                      d="M16.5,31.1125 L14.1075,28.9345 C5.61,21.229 0,16.147 0,9.91 C0,4.828 3.993,0.835 9.075,0.835 C11.946,0.835 14.7015,2.1715 16.5,4.2835 C18.2985,2.1715 21.054,0.835 23.925,0.835 C29.007,0.835 33,4.828 33,9.91 C33,16.147 27.39,21.229 18.8925,28.951 L16.5,31.1125 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    case 'chart':
      return (
        <svg
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          className={className}
          version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <g
            id="Desktop-Copy-3"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd">
            <g
              id="Desktop-Home-Copy-6"
              transform="translate(-100.000000, -1383.000000)"
              fill={primary ? colors.primary : colors.secondary}
              fill-rule="nonzero">
              <g id="Group-16" transform="translate(100.000000, 1364.000000)">
                <g
                  id="ic_assessment_black_24px"
                  transform="translate(0.000000, 19.000000)">
                  <path
                    d="M26.6666667,0 L3.33333333,0 C1.5,0 0,1.5 0,3.33333333 L0,26.6666667 C0,28.5 1.5,30 3.33333333,30 L26.6666667,30 C28.5,30 30,28.5 30,26.6666667 L30,3.33333333 C30,1.5 28.5,0 26.6666667,0 Z M10,23.3333333 L6.66666667,23.3333333 L6.66666667,11.6666667 L10,11.6666667 L10,23.3333333 Z M16.6666667,23.3333333 L13.3333333,23.3333333 L13.3333333,6.66666667 L16.6666667,6.66666667 L16.6666667,23.3333333 Z M23.3333333,23.3333333 L20,23.3333333 L20,16.6666667 L23.3333333,16.6666667 L23.3333333,23.3333333 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )

    default:
      break
  }
}



// WEBPACK FOOTER //
// ../styleguide/src/Icon.jsx